import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  Button,
  InputGroup,
  InputGroupAppend,
  InputGroupPrepend,
  InputGroupText,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  TextInput,
} from '@met/react-components';
import React from 'react';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { toast } from 'react-toastify';

const ApiApplicationTokenModal = ({ hidden, toggle, token }) => {
  const onCopy = () => {
    toast.info('Token Copied');
  };

  return (
    <Modal centered hidden={hidden} toggle={toggle}>
      <ModalContent>
        <ModalHeader toggle={toggle}>Application Token</ModalHeader>
        <ModalBody>
          <p>
            This is your application token, you will only be shown it once, so
            copy it now!
          </p>
          <InputGroup>
            <InputGroupPrepend>
              <InputGroupText>Token</InputGroupText>
            </InputGroupPrepend>
            <TextInput value={token} readonly />
            <InputGroupAppend>
              <InputGroupText>
                <CopyToClipboard text={token} onCopy={onCopy}>
                  <FontAwesomeIcon icon='copy' />
                </CopyToClipboard>
              </InputGroupText>
            </InputGroupAppend>
          </InputGroup>
        </ModalBody>
        <ModalFooter>
          <Button onClick={toggle}>Close</Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default ApiApplicationTokenModal;
